import makeUseGlobalClientState, {
  UseGlobalClientStateOutput,
} from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

import {DataMappingState} from './DataMappingTypes';
import getDefaultDataMappingState from './getDefaultDataMappingState';

const dataMappingGlobalState = makeUseGlobalClientState<DataMappingState | null>(null);

export default function useDataMappingState(
  analysisId: string,
  dataFrameId: string,
  defaultDataMappingState?: DataMappingState
): [...UseGlobalClientStateOutput<DataMappingState>, () => void] {
  const clientStateId = `${analysisId}-${dataFrameId}-data-mapping`;
  const [globalDataMappingState, setGlobalDataMappingState] =
    dataMappingGlobalState.useGlobalClientState(clientStateId);

  const dataMappingState = globalDataMappingState ?? defaultDataMappingState ?? getDefaultDataMappingState();

  const resetDataMappingState = (): void => {
    setGlobalDataMappingState(null);
  };

  return [dataMappingState, setGlobalDataMappingState, resetDataMappingState];
}
